export const ipUrl = 'xrscm.xrdsnet.com'; // ip地址
// export const ipUrl = 'scm.xrdsnet.com'; // ip地址
